import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';

import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import './animate.css'

import 'semantic-ui-css/semantic.min.css'
import "bootstrap/dist/css/bootstrap.css";
import './nunito-font.css'
import './react-antd.css'
import './index.css';

import animationReducer from "./store/Reducer/AnimationReducer";
import spinnerReducer from "./store/Reducer/SpinnerReducer";
import historyReducer from "./store/Reducer/HistoryReducer";
import userReducer from "./store/Reducer/UserReducer";
import reception_SheduleMeetingReducer from "./store/Reducer/Reception_SheduleMeetingReducer";
import reception_VisitorCountReducer from "./store/Reducer/Reception_VisitorCountReducer";
import viewAllCheckINReducer from "./store/Reducer/ViewAllCheckINReducer";
import imageReducer from "./store/Reducer/ImageReducer";
/**
* Socket configuration
*/
import receptSocketReducer from "./store/Reducer/Reception/SocketReducer";

/**
 * Corporate Admin Reducers
 */
import COPLocationReducer from "./store/Reducer/Corporate/LocationReducer";
import COPUserReducer from "./store/Reducer/Corporate/CopUserReducer";
import COPAdminReducer from "./store/Reducer/Corporate/CopAdminReducer";
import COPReceptionReducer from "./store/Reducer/Corporate/ReceptionReducer";
import userGroupReducer from "./store/Reducer/Corporate/UserGroupReducer";

/**
 * Host Reducer
 */
import hostReducer from "./store/Reducer/Host/HostReducer"

/**
 * Super Admin Reducers
 */
import addCorporateReducer from "./store/Reducer/SuperAdmin/AddCorporateReducer";
import systemChangeReducer from "./store/Reducer/SuperAdmin/SystemReducer"
import viewAllReducer from "./store/Reducer/SuperAdmin/ViewAllCorporateReducer"

import { createBrowserHistory } from "history";

/**
 *
 * Event Reducers
 */
import eventOrganizerReducer from "./store/Reducer/Event/EventOrganizerReducer";
import eventPublicSpeakerReducer from "./store/Reducer/Event/EventPublicSpeakerReducer";
import subEventReducer from "./store/Reducer/Event/CreateSubEventReducer";
import eventReducer from "./store/Reducer/Event/CreataeEventReducer";
import fileUploadReducer from "./store/Reducer/FileUploadReducer";
import agendaEventReducer from "./store/Reducer/Event/AgendaEventReducer";
import invitationReducer from "./store/Reducer/Event/InvitationReducer";
import participantReducer from "./store/Reducer/Event/participantReducer";
import organizerReducer from "./store/Reducer/organizerReducer";
import notificationReducer from "./store/Reducer/Event/notificationReducer";
import feedbackReducer from "./store/Reducer/Event/FeedbackReducer";
import socketReducer from "./store/Reducer/Event/SocketReducer";

/**
 *
 * Guest User Reducers
 */
import guestUserReducer from "./store/Reducer/Guest/GuestUserReducer";

/**
 *
 *  Workspace Reducer
 */
import workspaceReducer from "./store/Reducer/Space/WorkspaceReducer";

// Language Configurations
import './i18n';


const hist = createBrowserHistory();
const rootReducer = combineReducers({
  animationReducer: animationReducer,
  spinnerReducer:spinnerReducer,
  historyReducer:historyReducer,
  userReducer:userReducer,
  reception_SheduleMeetingReducer:reception_SheduleMeetingReducer,
  reception_VisitorCountReducer:reception_VisitorCountReducer,
  viewAllCheckIN:viewAllCheckINReducer,
  COPLocationReducer:COPLocationReducer,
  COPUserReducer:COPUserReducer,
  COPAdminReducer:COPAdminReducer,
  COPReceptionReducer:COPReceptionReducer,
  imageReducer:imageReducer, //image handler
  //host
  hostReducer:hostReducer,
  // super admin
  addCorporateReducer:addCorporateReducer,
  systemChangeReducer: systemChangeReducer,
  viewAllReducer: viewAllReducer,
  // -----------
  //Event
  eventOrganizerReducer: eventOrganizerReducer,
  eventPublicSpeakerReducer: eventPublicSpeakerReducer,
  subEventReducer: subEventReducer,
  eventReducer: eventReducer,
  fileUploadReducer: fileUploadReducer,
  agendaEventReducer: agendaEventReducer,
  invitationReducer: invitationReducer,
  participantReducer: participantReducer,
  notificationReducer :  notificationReducer,
  feedbackReducer : feedbackReducer,
  socketReducer: socketReducer,
  receptSocketReducer: receptSocketReducer,

  //eventOrganizer
  organizerReducer :  organizerReducer,

  //guest user
  guestUserReducer : guestUserReducer,

  //user group
  userGroupReducer: userGroupReducer,

  //workspace
  workspaceReducer: workspaceReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const devTools =
//   process.env.NODE_ENV === "production"
//     ? applyMiddleware(...middlewares)
//     : composeWithDevTools(applyMiddleware(...middlewares));
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
// const store = createStore(rootReducer);

ReactDOM.render(<Provider store={store}><App history={hist} /></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
